import {
  MockMap,
} from '@ama-sdk/core';
import {
  AcceptanceRepository,
  combineCheckInBaggagePolicies,
  createAcceptance,
  createJourneyElement,
  createJourneyElementCommon,
  createMockData,
  createMockDataWithResponse,
  MockAcceptance,
  MockJourneyElementCommon,
} from '@dapi/sdk/spec';
import {
  namedTraveler,
} from '../../mock';
import {
  acceptedJourney,
  boardingPassResultWithChangeSeatNumber,
  boardingPassResultWithFreeSeatNumber,
  defaultCheckInBaggagePolicies,
  firstCHSeatOnJourney,
  journeys,
  noItemToPayError,
  owtripSeatmap,
  secondFreeSeatOnJourney,
} from '../../mock/data';

/**
 * OW 1Journey
 * 1ADT
 * update seats
 */

const checkedInJourneyElementFirstSeat: MockJourneyElementCommon = createJourneyElementCommon({
  template: {
    journeyElement: createJourneyElement({
      template: {
        seat: secondFreeSeatOnJourney[0],
        checkInStatus: 'accepted',
        traveler: namedTraveler,
        travelerId: namedTraveler.id
      }
    })
  }
});

const acceptance: MockAcceptance = createAcceptance({
  template: {
    checkedInJourneyElements: [checkedInJourneyElementFirstSeat],
    isAccepted: true
  }
});

export const ow1Journey1AdtUpdateSeat: MockMap = {
  generateBoardingPasses: [
    createMockDataWithResponse(boardingPassResultWithFreeSeatNumber, 201),
    createMockDataWithResponse(boardingPassResultWithFreeSeatNumber, 201),
    createMockDataWithResponse(boardingPassResultWithChangeSeatNumber, 201),
    createMockDataWithResponse(boardingPassResultWithChangeSeatNumber, 201)
  ],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies([defaultCheckInBaggagePolicies]).items)],
  getJourneyUnpaidItems: [
    createMockData(noItemToPayError),
    createMockData(noItemToPayError),
    createMockData(noItemToPayError),
    createMockData(noItemToPayError),
    createMockData(noItemToPayError),
    createMockData(noItemToPayError),
    createMockData(noItemToPayError),
    createMockData(noItemToPayError)
  ],
  assignSeatToJourneyElement: [
    createMockDataWithResponse(firstCHSeatOnJourney[0], 201)
  ],
  updateJourneySeats: [
    createMockData(firstCHSeatOnJourney[0])
  ],
  updateJourneyElement: [
    createMockData(firstCHSeatOnJourney[0])
  ],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(acceptance, 201), createMockDataWithResponse(acceptance, 201)],
  retrieveJourneyBaggages: [createMockData([])],
  retrieveJourneys: [
    createMockDataWithResponse(journeys, 201),
    createMockDataWithResponse([acceptedJourney], 201)
  ],
  retrieveJourney: [
    createMockData({
      ...acceptedJourney,
      journeyElements: [checkedInJourneyElementFirstSeat]
    })
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(owtripSeatmap)]
};
